<template>
  <div id="pageRoot">

    <img src="/pages/img/sordovio/assets_p10/titulo.svg" style="width:580px; left: 80px; top: 60px; position: absolute;"/>

    <span class="normalTheme pageInstruction" style="left: 90px; top: 130px;">
      <p>Ordena las letras y escribe los nombres.</p>
    </span>

    <img
    style="width: 180px; top: 180px; left: 55px"
    class="pageElement"
    src="/pages/img/sordovio/assets_p10/burbujasGrillo.svg"
    />

    <saved-input v-bind:page="$parent.page" v-bind:type="$parent.type" defaultText="GRILLO" style="width: 432px;position: absolute; left: 300px; top: 230px" number=100 disabled/>

    <img
    style="width: 180px; top: 150px; left: 780px"
    class="pageElement basicItem01"
    src="/pages/img/sordovio/assets_p10/grillo.svg"
    />

    <img
    style="width: 200px; top: 370px; left: 55px"
    class="pageElement"
    src="/pages/img/sordovio/assets_p10/burbujasPajaro.svg"
    />

    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
    />

    <img
    style="width: 180px; top: 340px; left: 780px"
    class="pageElement basicItem01"
    src="/pages/img/sordovio/assets_p10/pajaro.svg"
    />

    <img
    style="width: 230px; top: 570px; left: 40px"
    class="pageElement"
    src="/pages/img/sordovio/assets_p10/burbujasGuitarrero.svg"
    />

    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="2"
      id="inputField02"
    />

    <img
    style="width: 180px; top: 580px; left: 780px"
    class="pageElement basicItem01"
    src="/pages/img/sordovio/assets_p10/guitarrero.svg"
    />

  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: 43px;
  top: 41px;
}
#inputField01 {
  position: absolute;
  width: 432px;
  left: 300px;
  top: 400px;
}
#inputField02 {
  position: absolute;
  width: 432px;
  left: 300px;
  top: 590px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: [
        "vio/Video 28.mp4",
        "vio/Video 29.mp4",
      ],
    };
  },
};
</script>